module.exports = __webpack_public_path__ + "static/media/26.9abb6d5e.jpg";